module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Terms of Service","updated_at":"Updated"},"ja":{"title":"利用規約","updated_at":"更新日"}}')
  delete Component.options._Ctor
}
